import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { ExpensesDto } from './expenses.dto';


export class AllExpensesResponse extends GlobalResponseObject{
    data?: ExpensesDto[];

    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
     constructor(status:boolean, intlCode:number, internalMessage:string, data?: ExpensesDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}